var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyCommunicationsDistrict({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.099,
    height: 24.031,
    viewBox: "0 0 31.099 24.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e911_emergency_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M8.008,30.031v-2.12h2.156l2.969-9.789a2.184,2.184,0,0,1,.76-1.1,1.994,1.994,0,0,1,1.255-.424h4.806a1.994,1.994,0,0,1,1.255.424,2.184,2.184,0,0,1,.76,1.1l2.969,9.789h2.156v2.12Zm4.418-2.12H22.674l-2.757-9.188H15.182Zm4.064-15.55V6h2.12v6.361Zm8.3,3.463-1.52-1.52L27.8,9.817,29.283,11.3Zm1.944,6.785V20.49H33.1v2.12ZM10.3,15.825,5.817,11.3,7.3,9.817,11.825,14.3ZM2,22.61V20.49H8.361v2.12Z",
    transform: "translate(-2 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyCommunicationsDistrict);
export default __webpack_public_path__ + "static/media/emergency-communications-district.b75e5db476d4cfefe1d9c450fcb57b18.svg";
export { ForwardRef as ReactComponent };